<template>
  <div class="_request-form">
    <b-row class="m-0">
      <!-- Form-->
      <b-col
        lg="12"
        class="d-flex align-items-center px-2 p-lg-5 mt-2">
        <b-col
          sm="12"
          md="8"
          lg="8"
          class="px-xl-2 mx-auto">
          <b-card>
            <b-card-title
              class="mb-1 font-weight-bold text-center"
              title-tag="h2">
              Olá, bem-vindo(a)!
            </b-card-title>
            <b-card-text class="mb-2" v-if="!headerDescription">
              Este formulário foi construído para você solicitar tratamento do(s) incidente(s) relacionados aos dados pessoais.<br><br>
            </b-card-text>
            <b-card-text class="mb-2" v-if="headerDescription" v-html-safe="headerDescription">
            </b-card-text>
                        <div class="mb-3 p-2 border rounded" style="background-color: #f8f9fa; border-color: #dee2e6;">
              <div class="d-flex align-items-start">
                <feather-icon icon="InfoIcon" size="16" class="text-info mr-2" />
                <div class="flex-grow-1">
                  <p class="mb-1 text-dark">
                    <strong>Já preencheu este formulário anteriormente?</strong>
                  </p>
                  <p class="mb-1 text-muted small">
                    Se você já cadastrou um formulário de incidente e deseja consultar, editar ou acompanhar a situação,
                    utilize a opção de busca.
                  </p>
                  <b-link @click="showPopupFindForm" class="text-primary font-weight-semibold small">
                    <feather-icon icon="SearchIcon" size="12" class="mr-1" />
                    Clique aqui para consultar seu formulário
                  </b-link>
                </div>
              </div>
            </div>

            <hr class="mb-4">

            <!-- form -->
            <validation-observer
              ref="requestForm">
              <b-form
                class="mb-1 mt-2"
                @submit.prevent="send">
                <!-- protocol number -->
                <b-form-group
                  :label="$t('incident_form_protocol')"
                  label-for="incident_form_protocol"
                  v-if="dataForm && dataForm.id">
                  <b-form-input
                    id="incident_form_protocol"
                    name="incident_form_protocol"
                    v-model="dataForm.protocol_number"
                    :disabled="true"
                    type="text"
                    readonly/>
                </b-form-group>
                <!-- only for edit form -->
                <b-form-group
                  :label="$t('incident_form_status')"
                  label-for="incident_form_status"
                  v-if="dataForm && dataForm.id">
                  <b-form-input
                    id="incident_form_status"
                    name="incident_form_status"
                    v-model="dataForm.status_str"
                    :disabled="true"
                    type="text"
                    readonly/>
                </b-form-group>

                <!-- incident type -->
                <b-form-group
                  :label="$t('type_form')"
                  label-for="type_form"
                  v-if="dataForm && dataForm.id">
                  <b-form-input
                    id="type_form"
                    name="type_form"
                    v-model="dataForm.type_form_str"
                    :disabled="true"
                    type="text"
                    readonly/>
                </b-form-group>
                 <!-- only for new form -->
                 <b-form-group
                    :label="$t('type_form')"
                    label-for="type_form"
                    v-else>
                    <validation-provider
                        #default="{ errors }"
                        :name="$t('type_form')"
                        rules="required">
                        <b-form-radio-group
                          v-model="typeForm"
                          :options="typeFormList"
                          value-field="key"
                          text-field="label"
                          name="typeForm"
                          stacked
                          @change="changeTypeForm"
                          :disabled="enableUpdateForm"/>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>

                  <!-- coup attempt type -->
                  <RequestFormIncidentCoupAttempt v-if="typeForm === 'CA'"
                    :param_encrypt="param_encrypt"
                    :typeForm="typeForm"
                    :dataForm="dataForm"
                    :disabledFields="disabledFields"
                    ref="coupAttempt"/>

                  <!-- general type -->
                  <RequestFormIncidentGeneral v-if="typeForm === 'GE'"
                    :param_encrypt="param_encrypt"
                    :typeForm="typeForm"
                    :dataForm="dataForm"
                    :disabledFields="disabledFields"
                    ref="general"/>

                  <!-- file upload -->
                  <div class="vx-row pt-2">
                    <div class="vx-col">
                      <!-- Additional attachments -->
                      <b-form-group
                        :label="$t('incident_form_attachments')"
                        label-for="incident_form_attachments">
                        <validation-provider
                            #default="{ errors }"
                            :name="$t('incident_form_attachments')">
                            <b-form-file
                              id="attachments"
                              placeholder="Clique para selecionar os arquivos ou arraste aqui..."
                              drop-placeholder="Solte os arquivos aqui..."
                              v-model="generalAttachments"
                              :state="errors.length > 0 ? false:null"
                              name="generalAttachments"
                              :disabled="disabledFields"
                              multiple
                              accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"/>
                            <small class="text-danger">{{ errors[0] }}</small>
                            <small class="form-text text-muted">
                              <i class="feather icon-upload mr-1"></i>
                              Selecione um ou mais arquivos para anexar. Todos os anexos são opcionais.
                            </small>
                            <div v-if="generalAttachments && generalAttachments.length" class="mt-2">
                              <b-list-group>
                                <b-list-group-item v-for="(file, idx) in generalAttachments" :key="idx" class="d-flex justify-content-between align-items-center">
                                  <div>
                                    <i class="feather icon-file-text text-primary mr-2"></i>
                                    <a v-if="getDownloadUrl(file)"
                                       :href="getDownloadUrl(file)"
                                       target="_blank"
                                       class="mr-2 download-link text-primary"
                                       title="Baixar arquivo">
                                      <i class="feather icon-download"></i>
                                    </a>
                                    <strong>{{ getFileName(file) }}</strong>
                                    <small class="ml-2 text-muted" v-if="getFileSize(file)">
                                      ({{ formatFileSize(getFileSize(file)) }})
                                    </small>
                                  </div>
                                  <b-button variant="outline-danger" size="sm" v-if="enableUpdateForm" @click="removeAttachment(idx)">
                                    <i class="feather icon-trash-2"></i>
                                  </b-button>
                                </b-list-group-item>
                              </b-list-group>
                            </div>
                        </validation-provider>
                      </b-form-group>

                    </div>
                  </div>

                  <!-- submit buttons -->
                  <div class="vx-row pt-2">
                    <div class="vx-col w-full d-flex justify-content-end">
                        <b-button
                          v-if="enableSubmit"
                          type="submit"
                          variant="primary"
                          class="waves-effect float-right mr-2">
                          Enviar
                        </b-button>
                        <b-button
                          v-if="enableUpdateForm"
                          type="submit"
                          variant="primary"
                          class="waves-effect float-right mr-2">
                          Salvar
                        </b-button>

                        <b-button
                          type="button"
                          variant="secondary"
                          class="waves-effect float-right"
                          @click="clearFields">
                          Limpar
                        </b-button>
                    </div>
                  </div>
              </b-form>
            </validation-observer>
            <!-- end form-->
            <b-card-footer class="text-right">
              <small class="text-muted">Desenvolvido por:</small> &nbsp;&nbsp;
              <b-link href="https://securamdata.com" target="_brank">securamdata.com</b-link>
            </b-card-footer>
          </b-card>
        </b-col> <!-- b-col-->
      </b-col>
    </b-row>
    <b-modal width="550px" v-model="activeDialogAge"
             title="Procotolo"
             ok-only
             centered>
        <div class="con-content">
          <p>
              {{protocolNumber}}
          </p>
          <p v-html="msgDescription">
          </p>
        </div>
    </b-modal>
    <b-modal width="550px" v-model="activeDialogFindForm"
             title="Corrigir formulário preenchido"
             hide-footer
             centered>
        <div class="con-content">
          <b-form>
            <b-form-group
              label="E-mail do cadastro:"
              label-for="search-email">
              <b-input-group>
                <b-input-group-prepend>
                  <b-input-group-text>
                    <feather-icon icon="MailIcon" size="16" />
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  id="search-email"
                  v-model="searchFormData.email"
                  type="email"
                  placeholder="Digite o e-mail usado no cadastro do formulário"
                  required>
                </b-form-input>
              </b-input-group>
            </b-form-group>

            <b-form-group
              label="Protocolo:"
              label-for="search-protocol">
              <b-input-group>
                <b-input-group-prepend>
                  <b-input-group-text>
                    <feather-icon icon="FileTextIcon" size="16" />
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  id="search-protocol"
                  v-model="searchFormData.protocol"
                  placeholder="Digite o número do protocolo"
                  required>
                </b-form-input>
              </b-input-group>
            </b-form-group>

            <div class="text-right mt-3 d-flex justify-content-end">
              <b-button
                variant="primary"
                @click="searchFormDataMethod"
                :disabled="!searchFormData.email || !searchFormData.protocol">
                <feather-icon icon="SearchIcon" class="mr-50"/>
                Consultar
              </b-button>
              <b-button
                variant="outline-secondary"
                class="ml-2"
                @click="activeDialogFindForm = false">
                <span class="align-middle">Cancelar</span>
              </b-button>
            </div>
          </b-form>
        </div>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BLink,
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroupPrepend,
  BInputGroupText,
  BInputGroup,
  BFormCheckbox,
  BFormRadioGroup,
  BFormCheckboxGroup,
  BFormTextarea,
  BFormFile,
  BCard,
  BCardText,
  BCardTitle,
  BCardFooter,
  BImg,
  BButton,
  BAlert,
  VBTooltip,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'

import standard from '@/services/standard'

import RequestFormIncidentGeneral from './RequestFormIncidentGeneral.vue'
import RequestFormIncidentCoupAttempt from './RequestFormIncidentCoupAttempt.vue'

import FeatherIcon from '@/components/FeatherIcon.vue'
import RequestFormIncidentService from '@/services/api/incident/RequestFormIncidentService'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BInputGroupText,
    BInputGroup,
    BFormCheckbox,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BFormTextarea,
    BFormFile,
    BCard,
    BCardText,
    BCardTitle,
    BCardFooter,
    BImg,
    BForm,
    BButton,
    BAlert,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    flatPickr,
    RequestFormIncidentGeneral,
    RequestFormIncidentCoupAttempt,
    FeatherIcon,
  },
  props: {
    param_encrypt: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      status: '',
      typeForm: 'GE',
      //
      protocolNumber: '',
      generalAttachments: [],
      // Dialog states
      activeDialogAge: false,
      activeDialogFindForm: false,
      msgDescription: '',
      searchFormData: {
        email: '',
        protocol: ''
      },
      dataForm: null, //Dados retornados do backend, para edição
      //
      typeFormList: [
        { key: 'GE', label: this.$t('type_form_general') }, //General
        { key: 'CA', label: this.$t('type_form_coup_attempt') }, //Coup Attempt
      ],
      // validation rules
      required,
      email,
      isDevEnv: [
        'localhost',
        '127.0.0.1',
        '0.0.0.0',
        'dev',
        'teste',
        'test',
        'homolog',
        'homologacao',
        'staging'
      ].some(env => window.location.hostname.includes(env)),
      services: {
        requestFormIncidentService : null,
      }
    }
  },
  watch: {

  },
  computed: {
    validateForm() {

    },
    statusForm() {
      return this.dataForm && this.dataForm.status ? this.dataForm.status : '';
    },
    enableSubmit() {
      return !(this.dataForm && this.dataForm.id)
    },
    enableUpdateForm() {
      return this.dataForm && this.dataForm.id && (this.dataForm.status === 'DR' || this.dataForm.status === 'RC') ? true : false;
    },
    disabledFields() {
      if(this.dataForm && this.dataForm.id){
        if(this.dataForm.status === 'DR' || this.dataForm.status === 'RC'){
          return false
        }else{
          return true
        }
      }
      return false
    }
  },
  methods: {
    // Utils de anexos
    getFileName(file) {
      if (!file) return ''
      if (file.name) return file.name
      if (file.file_name) return file.file_name
      if (file.metadata && file.metadata.original_name) return file.metadata.original_name
      return 'Arquivo anexado'
    },
    getFileSize(file) {
      if (!file) return null
      if (file.size) return file.size
      if (file.metadata && file.metadata.size) return file.metadata.size
      return null
    },
    getDownloadUrl(file) {
      if (!file) return null
      if (file.url_tmp) return file.url_tmp
      if (file.metadata && file.metadata.url_tmp) return file.metadata.url_tmp
      if (file.url_temp) return file.url_temp
      if (file.url) return file.url
      if (file.download_url) return file.download_url
      return null
    },
    formatFileSize(size) {
      if (!size) return ''
      if (size < 1024) return size + ' B'
      if (size < 1024 * 1024) return (size / 1024).toFixed(1) + ' KB'
      return (size / (1024 * 1024)).toFixed(1) + ' MB'
    },
    changeTypeForm(value){
      this.typeForm = value;
      this.$nextTick(() => {
        if(value === 'CA' && this.$refs.coupAttempt) {
          this.$refs.coupAttempt.clearFields();
        } else if(value === 'GE' && this.$refs.general) {
          this.$refs.general.clearFields();
        }
      });
    },
    send() {
      this.$refs.requestForm.validate().then(success => {
        if (success) {
          this.clearErrors(this.$refs.requestForm)
          this.sendForm()
        }else{
          console.log('error!', success)
          this.errorAlertFormValidaded()
        }
      },
      error => {
        console.log('error: ', error)
      })
    },
    sendForm(){
      this.$vs.loading()
      const params = this.getDataFields();
      // Montar FormData com a estrutura correta
      const formData = new FormData();
      // Campos principais
      formData.append('typeForm', params.typeForm);
      formData.append('data_encrypt', params.data_encrypt);
      // data_form: todos os campos dos componentes filhos, exceto arquivos
      const dataFormObj = {};
      if (params.data_form) {
        for (const key in params.data_form) {
          // Se for array de arquivos, não inclui no JSON
          if (Array.isArray(params.data_form[key]) && params.data_form[key].length > 0 && params.data_form[key][0] instanceof File) {
            // Adiciona os arquivos ao FormData na raiz
            params.data_form[key].forEach(file => {
              formData.append(`${key}[]`, file);
            });
          } else {
            dataFormObj[key] = params.data_form[key];
          }
        }
      }
      // Adiciona os arquivos anexados gerais
      if (this.generalAttachments && this.generalAttachments.length > 0) {
        this.generalAttachments.forEach(file => {
          formData.append('generalAttachments[]', file);
        });
      }
      // Adiciona os arquivos do componente filho (RequestFormIncidentGeneral)
      if (this.typeForm === 'GE' && params.data_form && params.data_form.communicationContentAttachments && params.data_form.communicationContentAttachments.length > 0) {
        params.data_form.communicationContentAttachments.forEach(file => {
          formData.append('communicationContentAttachments[]', file);
        });
      }
      // Adiciona o objeto data_form como JSON
      formData.append('data_form', JSON.stringify(dataFormObj));

      if(this.dataForm && this.dataForm.id){
        this.services.requestFormIncidentService.updateFormData(this.dataForm.id, formData).then(
          data => {
            this.successUpdate(data)
          }
        ).finally(() => {
          this.$vs.loading.close()
        })
      }else{
        // Envia via serviço
        this.services.requestFormIncidentService.saveFormData(formData).then(
          data => {
            this.successSend(data)
            this.clearFields()
          },
          error => {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'Erro',
              text: 'Ocorreu um erro ao enviar o formulário!',
              color: 'danger',
              icon: 'bx bx-error'
            })
            this.showErrors(this.$refs.requestForm, error)
          }
        ).finally(() => {
          this.$vs.loading.close()
        })
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    successSend(data){
      this.sucessAlertPrococol(data);
      this.clearFields()
      this.scrollToTop()
      this.$vs.loading.close()
    },
    successUpdate(data){
      this.notifySuccess(this.$vs, 'Formulário atualizado com sucesso!', 5000, 'top-center')
      this.clearFields()
      this.scrollToTop()
      this.$vs.loading.close()
    },
    getDataFields(){
      const params = {
        typeForm: this.typeForm,
        data_encrypt: this.param_encrypt,
      }
      // Encapsular dados dos componentes filhos
      let data_form = {};
      if (this.typeForm === 'CA' && this.$refs.coupAttempt) {
        data_form = this.$refs.coupAttempt.getFormData();
      } else if (this.typeForm === 'GE' && this.$refs.general) {
        data_form = this.$refs.general.getFormData();
      }
      return {
        ...params,
        data_form: data_form
      };
    },
    clearFields() {
      this.typeForm = 'GE';
      this.dataForm = null;
      //Clear fields from components
      if(this.$refs.coupAttempt){
        this.$refs.coupAttempt.clearFields();
      }
      if(this.$refs.general){
        this.$refs.general.clearFields();
      }

      this.generalAttachments = []
      this.scrollToTop()

      this.$nextTick( () => {this.clearErrors(this.$validator)})

    },
    sucessAlertPrococol(data){
      this.notifySuccess(this.$vs, 'Formulário enviado com sucesso!', 3000)
      let msg = `Suas informações foram registradas, seu número de protocolo é o ${data.protocol_number}. Você receberá uma cópia das informações no e-mail informado.`

      this.$vs.dialog({
        type: 'alert',
        color: 'success',
        title: 'Procotolo',
        acceptText: 'ok',
        text: msg,
        accept: this.clearFields,
      })
    },
    onfocusin(){
        setTimeout((ev)=>{
            this.$refs.incident_form_date.isOpen || this.$refs.incident_form_date.showCalendar(ev);
        }, 50)
    },
    errorAlertFormValidaded(){
      const firstField = this.$el.querySelector('.is-invalid')
      if(firstField){
        firstField.scrollIntoView()
      }
      this.notifyWarning(this.$vs, 'Preencha corretamente os campos do formulário!', 3000)
    },
    removeAttachment(idx){
      if(this.dataForm && this.dataForm.id && this.generalAttachments[idx].id){
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Remover anexo',
          acceptText: 'Sim',
          cancelText: 'Não',
          text: 'Tem certeza que deseja remover este anexo? Esta ação não poderá ser desfeita.',
          accept: () => this.removeAttachmentPersist(idx)
        })
      }else{
        this.generalAttachments.splice(idx, 1)
      }
    },
    removeAttachmentPersist(idx){
      this.$vs.loading()
      this.services.requestFormIncidentService.deleteFile(this.dataForm.id, this.generalAttachments[idx].id).then(
          data => {
            this.notifySuccess(this.$vs, 'Anexo removido com sucesso!', 4000, 'top-center')
            this.generalAttachments.splice(idx, 1)
          }
        ).finally(() => {
          this.$vs.loading.close()
        })
    },
    showPopupFindForm() {
      // Limpar os campos antes de abrir o modal
      this.searchFormData.email = ''
      this.searchFormData.protocol = ''
      this.activeDialogFindForm = true
    },
    searchFormDataMethod(){
      if (!this.searchFormData.email || !this.searchFormData.protocol) {
        this.$vs.notify({
          title: 'Atenção',
          text: 'Preencha o e-mail e protocolo para buscar o formulário.',
          color: 'warning',
          icon: 'bx bx-info-circle'
        })
        return
      }

      this.$vs.loading()

      const filters = {
        email: this.searchFormData.email,
        protocol: this.searchFormData.protocol
      }

      this.services.requestFormIncidentService.getFormData(filters).then(
        data => {
          if (data && data.id) {
            // Sucesso: dados encontrados
            this.$vs.notify({
              title: 'Sucesso',
              text: 'Formulário encontrado com sucesso!',
              color: 'success',
              icon: 'bx bx-check-circle'
            })

            // Aqui você pode processar os dados retornados
            console.log('Dados do formulário encontrado:', data)

            // Fechar o modal
            this.activeDialogFindForm = false

            // Limpar os campos de busca
            this.searchFormData.email = ''
            this.searchFormData.protocol = ''

            // Atualizar os dados do formulário
            this.dataForm = data;
            this.typeForm = this.dataForm.type_form;

            //Attachments
            this.generalAttachments = data.general_attachments;

          } else {
            this.$vs.notify({
              title: 'Não encontrado',
              text: 'Nenhum formulário foi encontrado com os dados informados.',
              color: 'warning',
              icon: 'bx bx-info-circle',
              duration: 4000,
              position: 'top-center'
            })
          }
        },
        error => {
          this.$vs.loading.close()
          console.error('Erro ao buscar formulário:', error)
          this.$vs.notify({
            title: 'Erro',
            text: 'Ocorreu um erro ao buscar o formulário. Tente novamente.',
            color: 'danger',
            icon: 'bx bx-error'
          })
        }
      ).finally(() => {
        this.$vs.loading.close()
      })
    }
  },
  mounted() {
    //console.log(this.param_encrypt)
  },
  beforeMount() {
    this.services.requestFormIncidentService = RequestFormIncidentService.build(this.$vs)

    const promisses = []

  }
}
</script>

<style lang="scss" scoped>
  @import '@core/scss/vue/libs/vue-flatpicker.scss';

  .radio.custom-control {
      margin-top: 5px;
  }

  .file-selector {
    padding: 55px;
    //font-weight: 600;
    background-color: #f9f9f9;
    color: #4e5b69;
    //z-index: -9;
  }
  .separator {
    position: relative;
  }
  .separator:after {
    position: absolute;
    content: "";
    height: 1px;
    width: 200px;
    background: #d8d8d8;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .separator-span {
    position: relative;
    background: #f9f9f9;
    padding: 0 4px;
    z-index: 9;
    font-size: 12px;
    color: #4e5b69;
  }
</style>

